export interface LifeIncrementRiskPayload {
  priceRice: boolean
  amountPriceRice: number
  allowsHiring: boolean
}

export default class LifeGetIncrementRiskResponse {
  priceRice: boolean
  amountPriceRice: string | number
  allowsHiring: boolean

  constructor(data: LifeIncrementRiskPayload) {
    this.priceRice = data.priceRice
    this.amountPriceRice = data.amountPriceRice
    this.allowsHiring = data.allowsHiring
  }
}
